const Opensource = [
  {
    id: 1,
    code: 'VSCODE',
    category: 'VSCode Extension',
    name: 'Console Logs Cleaner',
    link: 'https://marketplace.visualstudio.com/items?itemName=TirthPatel.console-log-vs-code-extension',
    description: 'VSCode extension to remove all console logs from your project',
  },
  {
    id: 2,
    code: 'VSCODE',
    category: 'VSCode Extension',
    name: 'React Barrel Export Generator',
    link: 'https://marketplace.visualstudio.com/items?itemName=TirthPatel.barrel-export',
    description: 'VSCode extension to generate files in barrel structure for React',
  },
  {
    id: 3,
    code: 'VSCODE',
    category: 'VSCode Extension',
    name: 'Code Line Counter',
    link: 'https://marketplace.visualstudio.com/items?itemName=TirthPatel.countlines',
    description: 'VSCode extension to count lines of code in your project',
  },
  {
    id: 4,
    code: 'PYTHON',
    category: 'Python Package',
    name: 'PyPower Projects',
    link: 'https://pypi.org/project/pypowerprojects/',
    description: 'Python package to create projects from templates',
  },
  {
    id: 5,
    code: 'PYTHON',
    category: 'Python Package',
    name: 'PyPower Games',
    link: 'https://pypi.org/project/pypowergames/',
    description: 'Python package to play games from the terminal developed using Python',
  },
  {
    id: 6,
    code: 'NPM',
    category: 'NPM Library',
    name: 'Date Time Formatter',
    link: 'https://www.npmjs.com/package/date-time-formatter-dayjs',
    description: 'DayJS based npm package to format date and time.',
  },
]

export { Opensource }
